import { render, staticRenderFns } from "./DispositivosSim.vue?vue&type=template&id=5e146d97&"
import script from "./DispositivosSim.vue?vue&type=script&lang=ts&"
export * from "./DispositivosSim.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports